import getStudentActivityProgress from './studentActivityProgress';

export default function getStudentTasksProgress({ taskActivities }) {
  const activityProgresses = taskActivities.map((taskActivity) => {
    return getStudentActivityProgress(taskActivity);
  });
  return calculateAveragesWithSlots(activityProgresses);
}

export function calculateAveragesWithSlots(activityProgresses) {
  const miniactivityProgresses = activityProgresses.flat();
  const accTotals = miniactivityProgresses.reduce(
    (acc, activity) => {
      return {
        progress:
          acc.progress +
          (activity.progress
            ? sumProperty('progress', activity.progressSlots)
            : 0),
        correct:
          acc.correct +
          (activity.correctness
            ? sumProperty('correct', activity.progressSlots)
            : 0),
        progressDivisor:
          acc.progressDivisor +
          (activity.progress ? activity.repetitions || 1 : 0),
        correctDivisor:
          acc.correctDivisor +
          (activity.correctness ? activity.repetitions || 1 : 0),
      };
    },
    { progress: 0, correct: 0, progressDivisor: 0, correctDivisor: 0 }
  );

  const totalProgress = accTotals.progressDivisor
    ? Math.ceil(accTotals.progress / accTotals.progressDivisor)
    : 100;
  const totalCorrect = accTotals.correctDivisor
    ? Math.ceil(
        (accTotals.correct / accTotals.correctDivisor) * (totalProgress / 100)
      )
    : 0;

  return {
    totalProgress,
    totalCorrect,
    correctness: accTotals.correctDivisor > 0,
  };
}

const sumProperty = (prop, arr) => arr.reduce((acc, cur) => acc + cur[prop], 0);
